import { Component } from '@angular/core';

@Component({
  selector: 'app-verificacion-ncelular',
  standalone: false,
  templateUrl: './verificacion-ncelular.component.html',
  styleUrl: './verificacion-ncelular.component.scss'
})
export class VerificacionNcelularComponent {

}
